import { Module } from 'vuex-smart-module';
import ClientsSharedActions from './actions';
import ClientsSharedGetters from './getters';
import ClientsSharedMutations from './mutations';
import ClientsSharedState from './state';

export default new Module({
  state: ClientsSharedState,
  mutations: ClientsSharedMutations,
  actions: ClientsSharedActions,
  getters: ClientsSharedGetters,
});
